import 'global.css';

import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import BugReportIcon from '@mui/icons-material/BugReport';
import CloseIcon from '@mui/icons-material/Close';

import { useScrollToTop } from 'hooks/use-scroll-to-top';

import { ThemeProvider } from 'theme/theme-provider';

import { Iconify } from 'components/iconify';
import ApiProvider from 'api/ApiProvider';
import AuthProvider from 'components/authentication/context/authContext';
import BerpRoutes from 'components/common/routes/BerpRoutes';
import LocaleProvider from 'components/i18n/LocaleProvider';
import LayoutProvider from 'components/Layout/LayoutProvider';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import QueryProvider from 'store/QueryProvider';
import { WorkflowDebugProvider, useWorkflowDebug } from 'components/Workflow/WorkflowDebugContext';
import { WebSocketProvider } from 'websocket';

const WorkflowDebugFab = () => {
  const ctx = useWorkflowDebug();
  if (!ctx || (!import.meta.env.DEV && localStorage.getItem('workflow_debug') !== '1')) return null;
  return (
    <IconButton
      size="small"
      onClick={ctx.toggle}
      sx={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        zIndex: 99999,
        width: 32,
        height: 32,
        backgroundColor: 'warning.main',
        color: '#fff',
        '&:hover': { backgroundColor: 'warning.dark' },
      }}
    >
      {ctx.open ? <CloseIcon sx={{ fontSize: 16 }} /> : <BugReportIcon sx={{ fontSize: 16 }} />}
    </IconButton>
  );
};

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  const githubButton = (
    <Fab
      size="medium"
      aria-label="Github"
      href="https://github.com/minimal-ui-kit/material-kit-react"
      sx={{
        zIndex: 9,
        right: 20,
        bottom: 20,
        width: 44,
        height: 44,
        position: 'fixed',
        bgcolor: 'grey.800',
        color: 'common.white',
      }}
    >
      <Iconify width={24} icon="eva:github-fill" />
    </Fab>
  );

  return (
    <QueryProvider>
      <ThemeProvider>
        <ErrorBoundary>
          <LayoutProvider>
            <ApiProvider>
              <AuthProvider>
                <LocaleProvider>
                  <WorkflowDebugProvider>
                    <WebSocketProvider>
                      <BerpRoutes />
                    </WebSocketProvider>
                    <WorkflowDebugFab />
                  </WorkflowDebugProvider>
                </LocaleProvider>
              </AuthProvider>
            </ApiProvider>
          </LayoutProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </QueryProvider>
  );
}
